"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const next_utils_enums_colors_1 = __importDefault(require("@gerenciatd/next.utils.enums.colors"));
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const react_redux_1 = require("react-redux");
const menu_1 = __importDefault(require("../../menu"));
const logo_1 = __importDefault(require("../../logo"));
const close_button_1 = __importDefault(require("../close-button"));
class BurguerModal extends react_1.Component {
    constructor(props) {
        super(props);
        this.closeModal = () => {
            const { addModal } = this.props;
            addModal({ id: 'closeAll' });
        };
        this.drawModal = () => {
            try {
                const modalParent = document.querySelector('.modal-root');
                modalParent.style.zIndex = '35';
                modalParent.style.height = '100vh';
                modalParent.style.top = '0px';
                const modalContent = document.querySelector('.Modal_content');
                modalContent.classList.add('modal-scroll-hidden');
            }
            catch (err) {
                console.error(err);
            }
        };
        this.state = {};
    }
    componentDidMount() {
        this.drawModal();
    }
    componentWillUnmount() {
        const modalParent = document.querySelector('.modal-root');
        modalParent.style.removeProperty('z-index');
        modalParent.style.removeProperty('top');
        modalParent.style.removeProperty('height');
        const modalContent = document.querySelector('.Modal_content');
        modalContent.classList.remove('modal-scroll-hidden');
    }
    render() {
        const { items, segmentMenu, options, account } = this.props;
        const iconColor = (0, next_utils_enums_colors_1.default)('BLUE');
        const colorGrey1 = (0, next_utils_enums_colors_1.default)('GREY1');
        return (react_1.default.createElement("div", { className: "header-modal-menu", "data-cy": "Header modal burger" },
            react_1.default.createElement("div", { className: "header-menu" },
                react_1.default.createElement("div", { className: "logo" },
                    react_1.default.createElement(logo_1.default, null)),
                react_1.default.createElement("div", { className: "close" },
                    react_1.default.createElement(close_button_1.default, { onClick: this.closeModal, color: iconColor, backgroundColor: "white", onHoverColor: colorGrey1, taggingInfo: {
                            componentName: 'header',
                            componentContent: 'closeBurger',
                            componentVariation: 'all',
                            componentPerso: '',
                            componentProduct: '',
                        } }))),
            react_1.default.createElement("div", { className: "sections", "data-cy": "Header menu list" },
                react_1.default.createElement(menu_1.default, { items: items, layout: "default", location: "burger" })),
            react_1.default.createElement("div", { className: "segment", "data-cy": "Header secondary menu list" },
                react_1.default.createElement("hr", { className: "separator" }),
                react_1.default.createElement(menu_1.default, { items: segmentMenu, layout: "default", location: "burger" }),
                react_1.default.createElement("hr", { className: "separator" })),
            react_1.default.createElement("div", { className: "options" },
                react_1.default.createElement(menu_1.default, { items: options, layout: "icons", location: "burger", account: account, isModalBurger: true }))));
    }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(BurguerModal);
//# sourceMappingURL=index.js.map